import { useEffect, useState } from "react";

const PENDING_STALE_MS = 5 * 60_000;

export function useChangeRequestPending(pendingAt: number | undefined): boolean {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (pendingAt === undefined) return undefined;
    setNow(Date.now());
    const id = setInterval(() => setNow(Date.now()), 10_000);
    return () => clearInterval(id);
  }, [pendingAt]);

  return pendingAt !== undefined && now - pendingAt < PENDING_STALE_MS;
}
